import type { TidalSandboxConfig } from './types.ts'

export const defaultConfig: TidalSandboxConfig = {
  // -----------------------------------------------
  addons: {
    msw: false,
    source: true,
  },

  // -----------------------------------------------
  appendToHead: '',
  base: undefined,
  disableHttp2: false,

  // -----------------------------------------------
  disableStrictMode: false,
  expandStoryTree: false,
  hmrHost: undefined,
  hmrPort: undefined,

  // -----------------------------------------------
  noWatch: false,
  onDevServerStart: () => {
    return
  },
  outDir: 'dist',
  port: 1999,
  previewPort: 8080,
  stories: 'src/**/*.stories.{js,jsx,ts,tsx}',

  // -----------------------------------------------
  viteConfig: undefined,
}
